import useFromPersonalizationParam from '../../hooks/nav/useFromPersonalizationParam';
import useCanViewPersonalizations from '../../hooks/auth/useCanViewPersonalizations';
import BaseErrorBoundary from '../shared/errorHandling/boundaries/BaseErrorBoundary';
import PersonalizationLink from './PersonalizationLink';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Checks if the user came from personalization editor and if so, renders a button to go back.
 * Otherwise, renders the children.
 * */
const BackToVariantsEditorWrapper = ({
  children,
  strategyId,
  actionSource,
  buttonProps = {}
}) => {
  const strategyIdFromQueryParams = useFromPersonalizationParam();
  const canViewPersonalization = useCanViewPersonalizations();
  if (!canViewPersonalization || !strategyIdFromQueryParams || strategyId !== strategyIdFromQueryParams // ensure matching strategy id
  ) {
    return children;
  }
  return /*#__PURE__*/_jsx(PersonalizationLink, Object.assign({
    strategyId: strategyIdFromQueryParams,
    "data-test-id": "personalization-back-button",
    use: "secondary-ghost",
    actionSource: actionSource
  }, buttonProps));
};
const BackToVariantsEditorWrapperWithErrorBoundary = props => /*#__PURE__*/_jsx(BaseErrorBoundary, {
  fallback: props.children,
  children: /*#__PURE__*/_jsx(BackToVariantsEditorWrapper, Object.assign({}, props))
});
export default BackToVariantsEditorWrapperWithErrorBoundary;